import { render, staticRenderFns } from "./Autonym.vue?vue&type=template&id=68586dc2&scoped=true"
import script from "./Autonym.vue?vue&type=script&lang=js"
export * from "./Autonym.vue?vue&type=script&lang=js"
import style0 from "./Autonym.vue?vue&type=style&index=0&id=68586dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68586dc2",
  null
  
)

export default component.exports